import { MapTo } from '@adobe/aem-react-editable-components';
import MobileAppQrCode, { MobileAppQrCodeEditConfig } from './MobileAppQrCode';

export default MapTo('cob-corp-acquisition/components/creditonebank/mobile-app-qr-code')(MobileAppQrCode, MobileAppQrCodeEditConfig);